import {useMemo} from "react";
import {useAssessments} from "traitify-widgets";

export default function useWidgetState() {
  const widgetAssessments = useAssessments();
  const assessments = useMemo(() => {
    if(!widgetAssessments) { return; }
    if(widgetAssessments.length === 0) { return; }

    return widgetAssessments;
  }, [widgetAssessments]);

  return {assessments};
}
